import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Navbar from '../components/navbar/Navbar'
import Footer from '../components/footer/Footer'
import Contact from '../components/contact/Contact'

export default function ContactPage() {
  usePageMeta({
    title: 'Contact & Location | Learning In Motion Academy, Tamarac FL',
    description: 'Visit Learning In Motion Academy at 6820 NW 70th Ave, Tamarac, FL 33321. Call 954-722-4880 to schedule a tour. Open 6:30am-6:30pm.',
    path: '/contact',
  })

  return (
    <>
      <Navbar/>
      <Contact/>
      <Footer/>
    </>
  )
}
